import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
  Router,
  NavigationEnd
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ParamService } from './../../shared/services/param.service';
import { B4UService } from './b4u.service';


@Injectable({
  providedIn: 'root',
})
export class TokenUserInfo implements Resolve<any> {
  private windowObj: any = window;
  banner: any;
  url: string;
  Options: any = {};

  constructor(
    private http: HttpClient,
    private paramService: ParamService,
    private b4uService: B4UService,
    private router: Router
  ) {
    this.banner = this.paramService.banner;
    if (window.location.href.indexOf('local') > 0) {
      // Using Unified Banners Call, if not unified, remove /unified/ from the url path
      this.url =
        this.b4uService.getApplicationDomainURL() +
        '/bin/safeway/unified/userinfo?banner=' +
        this.banner +
        '&rand=' +
        Math.random();
      console.log('TokenUserInfo ->', this.url);
      this.Options['withCredentials'] = true;
    } else {
      // Using Unified Banners Call, if not unified, remove /unified/ from the url path
      this.url = '/bin/safeway/unified/userinfo?banner=' + this.banner;
    }
   // Subscribe to router events to handle deals page visibility on every route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleDealsPageVisibility();
      });

    // Also call it initially
    this.handleDealsPageVisibility();
  }

  private handleDealsPageVisibility(): void {
  if (!window.location.pathname.includes('deals') || window.location.hostname.includes('business')) {
    $('#deals_page_content').css({
      'opacity': '0',
      'pointer-events': 'none',
      'height': '0',
      'overflow': 'hidden'
    });
  } else {
    $('#deals_page_content').css({
      'opacity': '1',
      'pointer-events': 'auto',
      'height': 'auto',
      'overflow': 'visible'
    });
  }
  // Update search placeholder based on current route
  this.updateSearchPlaceholder();
}

private updateSearchPlaceholder(): void {
  const searchInput = document.querySelector('.search-nav__input') as HTMLInputElement;
  const searchFormDiv = document.querySelector('div.search-nav__search-form') as HTMLElement;
  const searchContainer = document.querySelector('.search-container') as HTMLElement;
  const searchSuggestions = document.querySelector('.search-suggestion-container') as HTMLElement;
  const searchSuggestionsAuto = document.querySelector('.search-suggestion-container-auto') as HTMLElement;
  
  if (searchInput) {
    const currentPath = window.location.pathname;
    let searchFormRecreated = false;
    
    // Check if it's offer-details page or other product search pages
    if (currentPath.includes('offer-details')) {
       // Clear any existing search input
      searchInput.value = '';

      // Reset search button icons to show search icon (not close icon)
      const searchGreyIcon = document.querySelector('.searchBtn .svg-icon-search-grey') as HTMLElement;
      const searchCloseIcon = document.querySelector('.searchBtn .svg-icon-search-Close') as HTMLElement;
      if (searchGreyIcon) {
        searchGreyIcon.style.display = 'block';
      }
      if (searchCloseIcon) {
        searchCloseIcon.style.display = 'none';
      }
      
      // Configure for product search (offer-details and other pages)
      searchInput.placeholder = 'Search products';
      if (searchContainer) {
        searchContainer.setAttribute('data-searchtype', 'productSearch');
      }
      
      // Restore form functionality for product search - need to recreate the form element
      if (searchFormDiv && !document.querySelector('form.search-nav__search-form')) {
        // Convert div back to form
        const formElement = document.createElement('form');
        formElement.className = 'search-nav__search-form';
        formElement.setAttribute('action', '/shop/search-results.html');
        formElement.setAttribute('role', 'search');
        formElement.setAttribute('name', 'search-form');
        formElement.style.padding = '0px';
        
        // Move all children from div to form
        while (searchFormDiv.firstChild) {
          formElement.appendChild(searchFormDiv.firstChild);
        }
        
        // Replace div with form
        searchFormDiv.parentNode?.replaceChild(formElement, searchFormDiv);
        searchFormRecreated = true;
      }
      
      // Restore product search classes
      searchInput.className = 'search-nav__input form-control input-search ecomm-search product-search-enabled body-m';
      
      // Show suggestions for product search
      if (searchSuggestions) {
        searchSuggestions.classList.remove('force-hide-suggestions');
      }
      if (searchSuggestionsAuto) {
        searchSuggestionsAuto.classList.remove('force-hide-suggestions');
      }
      
      // Initialize product search functionality if not already initialized
      if (searchFormRecreated && this.windowObj.AB && this.windowObj.AB.COMMON && this.windowObj.AB.COMMON.searchInit ) {
        this.windowObj.AB.COMMON.searchInit();
      }
      
    } else if (currentPath.includes('coupons-deals') || currentPath.includes('deals') || currentPath.includes('foru-guest')) {
      
      // Configure for offers search (deals pages)
      searchInput.placeholder = 'Search offers';
      if (searchContainer) {
        searchContainer.setAttribute('data-searchtype', 'offerSearch');
      }
      
      // Convert form to div and disable submission for SPA pages
      const searchForm = document.querySelector('form.search-nav__search-form') as HTMLFormElement;
      if (searchForm) {
        // Create div replacement
        const divElement = document.createElement('div');
        divElement.className = 'search-nav__search-form';
        divElement.setAttribute('role', 'search');
        divElement.style.padding = '0px';
        
        // Move all children from form to div
        while (searchForm.firstChild) {
          divElement.appendChild(searchForm.firstChild);
        }
        
        // Replace form with div
        searchForm.parentNode?.replaceChild(divElement, searchForm);
      }
      
      // Reset classes for offer search
      searchInput.className = 'search-nav__input form-control input-search ecomm-search body-m';
      
      // Hide suggestions for offer search
      if (searchSuggestions) {
        searchSuggestions.classList.add('force-hide-suggestions');
      }
      if (searchSuggestionsAuto) {
        searchSuggestionsAuto.classList.add('force-hide-suggestions');
      }
    }
  }
}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Observable<never> {
    return this.http.get(this.url, this.Options);
  }
}
